import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaBigIntDefinition } from './TypedDefinition'

export const SchemaBigIntPlugin = createSchemaPlugin(
  'Schema.BigInt',
  SchemaBigIntDefinition
)
